export default class Regiao {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.composicao = '';

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
        this.composicao = model.composicao;
    }
}